import { useState, useEffect } from 'react';
import { isEmptyArray, isNil } from '@srcDS/utils/assertions';

export const useEmptyResultCheck = (data: any, triggerRoute: any) => {
  const [emptyResult, setEmptyResult] = useState<boolean>(false);
  const stream = data?.stream || {};

  useEffect(() => {
    const a_setFilters = stream?.query?.filter || null;
    setEmptyResult(
      (isNil(a_setFilters) || isEmptyArray(a_setFilters)) &&
      !stream?.items?.length
    );
  }, [stream, triggerRoute]);

  return { emptyResult };
};